import { render } from "./PersonCheckIcon.vue?vue&type=template&id=0321263b"
import script from "./PersonCheckIcon.vue?vue&type=script&lang=js"
export * from "./PersonCheckIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__